<p-dialog [(visible)]="display" (onHide)="onDialogHide()" appendTo="body" [resizable]="false" [closable]="true">

  <p-header>
    <span>Enter Google Workspace admin credentials</span>
  </p-header>

  <div style="width: 750px; margin-top: 10px; margin-bottom: 10px; margin-left: 10px;">
    @if (messageType === 'user') {
      <div>
        <p>
          Your Google Workspace admin credentials are needed to retrieve user information from Google.
        </p>
        <h4>The Information We Collect</h4>
        <p>
          UVexplorer Server retrieves a small amount of personal information from Google, including:
        </p>
        <ol>
          <li>Google user login names</li>
          <li>Google user email addresses</li>
          <li>Google user account identifiers</li>
        </ol>
        <h4>How We Use Your Information</h4>
        <p>
          Google user account information is used to connect UVexplorer Server user accounts with their corresponding Google user accounts.
        </p>
        <h4>How We Store Your Information</h4>
        <p>
          Collected Google user account information is stored in UVexplorer Server's database.
          It is stored in an encrypted form so it cannot be read by someone who gains access to UVexplorer Server's database.
        </p>
        <h4>How We Share Your Information</h4>
        <p>
          We do not share your Google information with anyone.
        </p>
      </div>
    }

    @if (messageType === 'group') {
      <div>
        <p>
          Your Google Workspace admin credentials are needed to retrieve group information from Google.
        </p>
        <h4>The Information We Collect</h4>
        <p>
          UVexplorer Server retrieves a small amount of group information from Google, including:
        </p>
        <ol>
          <li>Google group identifiers</li>
          <li>Google group names</li>
          <li>Google group member identifiers (users and groups)</li>
        </ol>
        <h4>How We Use Your Information</h4>
        <p>
          Google user group information is used to connect UVexplorer Server user groups with their corresponding Google user groups.
        </p>
        <h4>How We Store Your Information</h4>
        <p>
          Collected Google user group information is stored in UVexplorer Server's database.
          It is stored in an encrypted form so it cannot be read by someone who gains access to UVexplorer Server's database.
        </p>
        <h4>How We Share Your Information</h4>
        <p>
          We do not share your Google information with anyone.
        </p>
      </div>
    }
  </div>

  <p-footer>
    <div style="margin-top: 10px; margin-bottom: 10px; text-align: center;">
      <button type="button" class="google-button" (click)="ok()" autofocus>&nbsp;</button>
      <button type="button" pButton class="cancel-button" icon="fa fa-close" (click)="cancel()" label="Cancel"></button>
    </div>
  </p-footer>

</p-dialog>
